import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getSummary({
    devcType,
    devcMassId,
    start,
    end,
    aggregatedUnit,
    aggregatedLength,
    showDetails,
    timezone = new Date().getTimezoneOffset() / -60,
  }) {
    return axiosInstance.get(`/summary/aggregated/period/${start}/${end}`, {
      params: {
        devcType,
        devcMassId,
        start,
        end,
        aggregatedUnit,
        aggregatedLength,
        showDetails,
        timezone,
      },
      cancelToken: getNewCancelToken(),
    });
  },

  // Trail posisi buat peta — payload kompak (fields + trail array-of-array),
  // butuh permission read Summary_Trail. HOUR×1 = interval yang dilayani cache backend.
  getTrail({
    devcMassId,
    start,
    end,
    timezone = new Date().getTimezoneOffset() / -60,
  }) {
    return axiosInstance.get(`/summary/trail/${start}/${end}`, {
      params: {
        devcMassId,
        aggregatedUnit: 'HOUR',
        aggregatedLength: 1,
        timezone,
      },
      cancelToken: getNewCancelToken(),
    });
  },

  // Endpoint rollup baru (BE 2026-08-16). Gak ngirim blok `data` (deret waktu),
  // jadi payload-nya jauh lebih kecil dari /summary/aggregated/period.
  getAssetSummaryRollup({
    devcType,
    devcMassId,
    start,
    end,
  }) {
    return axiosInstance.get(`/summary/asset/period/${start}/${end}`, {
      params: {
        devcType,
        devcMassId,
      },
      cancelToken: getNewCancelToken(),
    });
  },
};
